import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { waLink } from "@/config";

export const WhatsAppFloat = () => (
  <motion.a
    href={waLink("Hi Deal 2 Wheel! I have a question.")}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="whatsapp-float-button"
    aria-label="Chat on WhatsApp"
    className="fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full bg-volt text-black flex items-center justify-center volt-glow"
    initial={{ scale: 0, rotate: -30 }}
    animate={{ scale: 1, rotate: 0 }}
    transition={{ delay: 1.6, type: "spring", stiffness: 260, damping: 18 }}
    whileHover={{ scale: 1.12 }}
    whileTap={{ scale: 0.94 }}
  >
    <MessageCircle className="w-6 h-6" />
  </motion.a>
);

export default WhatsAppFloat;
